import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import QuickCapture from "./quick-capture";

interface CaptureDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function CaptureDialog({ open, onOpenChange }: CaptureDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg p-0 overflow-hidden">
        <DialogHeader className="px-5 pt-5 pb-0">
          <DialogTitle className="text-base font-semibold">
            Capture rapide
          </DialogTitle>
        </DialogHeader>
        <div className="p-5 pt-3">
          <QuickCapture
            variant="default"
            onCaptured={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
